export enum ToastType {
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  ERROR = 'ERROR',
}

export type ToastProp = {
  onClose?: () => void;
  toastType: ToastType;
  title: string;
  subTitle?: string;
};
